// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__2e-IW","desc":"styles_desc__1yOpd","mainList":"styles_mainList__2ppz2","subList":"styles_subList__1qGw6","contactInfo":"styles_contactInfo__3VuPS"};